import type { WrappedParticipantStats, WrappedStats } from './wrapped-model';

export function personLabel(stats: WrappedParticipantStats | undefined): string {
  return stats?.participant.displayName ?? '—';
}

export function awardFor(stats: WrappedStats, kind: 'weekend' | 'category'): string {
  if (kind === 'category') {
    if (stats.favoriteCategory === 'Bier') return 'Bierkenner:in';
    if (stats.favoriteCategory === 'Cocktail') return 'Cocktail-Entdecker:in';
    if (stats.favoriteCategory === 'Wein') return 'Weinliebhaber:in';
    return 'Der Klassiker';
  }
  const weekendEvents = stats.events.filter((event) => {
    const weekday = new Date(event.occurredAt).getDay();
    return weekday === 0 || weekday === 5 || weekday === 6;
  }).length;
  return weekendEvents >= stats.events.length / 2 ? 'Wochenend-Profi' : 'Rund-ums-Jahr';
}

export function formatDecimal(value: number): string {
  return value.toLocaleString('de-DE', { maximumFractionDigits: 1 });
}
